import { LoggedOutGeneratorSection } from '../../../LoggedOutCodeGenerator.types'
import { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'

export const useProgressBarMobileSections = (): {
  id: LoggedOutGeneratorSection
  width: number
  label?: string
  groupId?: 'design'
}[] => {
  const { t } = useTranslation('logged-out-generator')

  return useMemo(
    () => [
      {
        id: LoggedOutGeneratorSection.ScanDestination,
        width: 1,
        label: t('LoggedOutGenerator.ProgressBar.mobile.sections.scanDestination.label')
      },
      {
        id: LoggedOutGeneratorSection.ColorSelector,
        width: 0.25,
        label: t('LoggedOutGenerator.ProgressBar.mobile.sections.codeDesign.label'),
        groupId: 'design'
      },
      {
        id: LoggedOutGeneratorSection.ShapeSelector,
        width: 0.25,
        groupId: 'design'
      },
      {
        id: LoggedOutGeneratorSection.FrameAndText,
        width: 0.25,
        groupId: 'design'
      },
      {
        id: LoggedOutGeneratorSection.Logo,
        width: 0.25,
        groupId: 'design'
      },
      {
        id: LoggedOutGeneratorSection.SignUp,
        width: 1,
        label: t('LoggedOutGenerator.ProgressBar.mobile.sections.signUp.label')
      }
    ],
    [t]
  )
}
